"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _PhoneInTalkOutlined = _interopRequireDefault(require("@material-ui/icons/PhoneInTalkOutlined"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _formatting = require("@sprinx/formatting");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderLeftColor: theme.palette.grey.A200,
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      borderRightColor: theme.palette.grey.A200,
      borderRightStyle: 'solid',
      borderRightWidth: 1,
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      marginLeft: theme.spacing(3)
    }, theme.breakpoints.down('sm'), {
      marginLeft: 0,
      borderRightWidth: 0,
      borderLeftWidth: 0,
      paddingLeft: 0,
      paddingRight: 0
    }),
    icon: {
      width: 25,
      height: 25
    },
    phone: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 500,
      paddingLeft: theme.spacing(1.5)
    }
  };
}, {
  name: 'NewsletterPhone'
});

function NewsletterPhone(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      phoneNumber = _ref.phoneNumber,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "phoneNumber"]);
  var classes = useStyles({
    classes: pClasses
  });

  if (phoneNumber.includes('@')) {
    var emailAdress = "mailto:".concat(phoneNumber.trim());
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
      className: (0, _clsx.default)(classes.root, className)
    }), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: emailAdress,
      component: "a",
      className: classes.phone
    }, phoneNumber));
  }

  var phoneNumberParsed = (0, _formatting.phoneParser)(phoneNumber);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_PhoneInTalkOutlined.default, {
    className: classes.icon
  }), /*#__PURE__*/_react.default.createElement(_Link.default, {
    href: phoneNumberParsed ? phoneNumberParsed.getURI() : '#',
    component: "a",
    className: classes.phone
  }, phoneNumberParsed ? phoneNumberParsed.formatInternational() : phoneNumber));
}

process.env.NODE_ENV !== "production" ? NewsletterPhone.propTypes = {
  classes: _propTypes.default.shape({
    icon: _propTypes.default.string,
    phone: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  phoneNumber: _propTypes.default.string
} : void 0;
NewsletterPhone.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = NewsletterPhone;
exports.default = _default;